import testingCommisionaAtionTypes from '../../actions/TestingCommission/TCActionTypes';

// Initial state for basic details
const initialOthersDetailsState = {
  isDataSetInEditMode: false,
  isEditMode: false,
    referenceNo: {
      IEC61010: false,
      IEC60601: false,
      IEC60950: false
    },
    class: {
      class1: false,
      class2: false,
      class3: false,
      IP: false,
      NA: false
    },
    type: {
      B: false,
      BF: false,
      CF: false,
      NA: false
    },
    powerCard: {
      nonDetachable: false,
      detachable: false,
      strainRelief: false,
      medicalGrade: false
    },
    proof: ''
  
}

const othersDetailsReducer = (state = initialOthersDetailsState, action) => {
  switch (action.type) {
    case testingCommisionaAtionTypes.SET_OTHERS_DETAILS_FIELDS:
      return {
        ...state,
        ...action.payload,

      };
      case testingCommisionaAtionTypes.RESET_OTHERS_DETAILS_FIELDS:
      return initialOthersDetailsState;
    default:
      return state;
  }
};

export default othersDetailsReducer;
